import { Box, Button, Typography } from "@mui/material";

import { ILocationDirection } from "../../services/location/location.interface";
import React from "react";

type IChooseHospitalCardProps = {
    currentLocationId: string;
    direction: ILocationDirection;
    handleSetLocationSubmit?: () => void;
}

const ChooseHospitalCard = (props: IChooseHospitalCardProps) => {
  const { currentLocationId, direction, handleSetLocationSubmit } = props;

  return (
    <>
      <div className="image-container">
        {currentLocationId! !== direction.idLocation && (
          <Typography variant="body1">Select hospital</Typography>
        )}
        <img src={direction.background} alt={direction.locationName}/>
      </div>

      <div className={`info ${currentLocationId! === direction.idLocation ? "bg-gv-yellow-light": undefined }`}>
        <Typography variant="h1" >
          {direction.locationName} {" "}
        </Typography>
        <Typography variant="body1" className="font-semibold">
          {direction.locationAddress}
        </Typography>
        <Typography variant="body1" className="text-gv-gold">
                ({direction.distance.text})
        </Typography>
        {currentLocationId! === direction.idLocation &&
                <Box className="set_hospital_btn">
                  <Button variant="contained" id="setAsHomeHospitalButton" color="primary"
                    fullWidth type="submit" onClick={handleSetLocationSubmit && handleSetLocationSubmit}
                    className="!normal-case !font-semibold"> Set as Home Hospital</Button>
                </Box>}
      </div>
    </>
  );
};

export default ChooseHospitalCard;
